const ACTION_REGISTER = 'register';
const ACTION_LOGIN = 'login';

export { ACTION_LOGIN, ACTION_REGISTER };
